const _lut_u8b2 = /* #__PURE__ */ Array.from(Array(256),
  (_, v) => v.toString(2).padStart(8, '0'));

function u8_to_base2(u8, sep) {
  if (undefined === u8.buffer) {
    u8 = new Uint8Array(u8);}

  let s = '';
  sep = null==sep ? '' : ''+sep;

  // 20x faster than Array.from/.map impl
  for (const v of u8) {
    s += _lut_u8b2[v & 0xff];
    s += sep;}

  return sep.length ? s.slice(0, -sep.length) : s}


function base2_to_u8(bits) {
  bits = bits.replace(/[^01]/g, '');
  const u8 = new Uint8Array(bits.length >> 3);
  for (let i=0, i2=0; i<u8.length; i++, i2+=8) {
    u8[i] = parseInt(bits.slice(i2, i2+8), 2); }
  return u8}

const _lut_u8hex = /* #__PURE__ */ Array.from(Array(256),
  (_, v) => v.toString(16).padStart(2, '0'));

function u8_to_hex(u8, sep) {
  if (undefined === u8.buffer) {
    u8 = new Uint8Array(u8);}

  let s = '';
  sep = null==sep ? '' : ''+sep;

  // 20x faster than Array.from/.map impl
  for (const v of u8) {
    s += _lut_u8hex[v & 0xff];
    s += sep;}

  return sep.length ? s.slice(0, -sep.length) : s}


const _lut_hexu8 = {
  0: 0x0, 1: 0x1, 2: 0x2, 3: 0x3, 4: 0x4, 5: 0x5, 6: 0x6, 7: 0x7, 8: 0x8, 9: 0x9,
  a: 0xa, b: 0xb, c: 0xc, d: 0xd, e: 0xe, f: 0xf,
  A: 0xa, B: 0xb, C: 0xc, D: 0xd, E: 0xe, F: 0xf,};

function hex_to_u8(hex) {
  hex = hex.replace(/\W|_/g, '');
  if (1 & hex.length) {
    hex = '0'+hex; }// pad odd-length

  const len = hex.length >> 1, u8 = new Uint8Array(len);
  // ~55% faster than parseInt
  for (let i=0,j=0; i<len; j+=2) {
    u8[i++] = (_lut_hexu8[hex[j]] << 4) | _lut_hexu8[hex[j+1]];}
  return u8}

const u8_to_base64url = /* #__PURE__ */ (()=>{
  let s = {'+':'-','/':'_','=':''};
  let m = c => s[c];
  let rx = /[+=\/]/g;
  return u8 => u8_to_base64(u8).replace(rx, m)
})();

function u8_to_utf8(u8) {
  return new TextDecoder('utf-8').decode(u8) }

function utf8_to_u8(utf8) {
  return new TextEncoder('utf-8').encode(utf8) }

function utf8_to_u8_nfkc(utf8) {
  return utf8_to_u8(utf8.normalize('NFKC')) }

const u8_json_codec ={
  encode: obj => utf8_to_u8(JSON.stringify(obj))
, decode: u8 => JSON.parse(u8_to_utf8(u8))};

let _u8_randomFill =  
  'undefined' !== typeof crypto
    ? crypto.getRandomValues.bind(crypto)
    : import('node:crypto')
        .then(m => m.randomFillSync);

async function u8_randomFill_p(z) {
  if ('function' !== typeof _u8_randomFill) {
    _u8_randomFill = await _u8_randomFill;}
  return _u8_randomFill(z)}

const u8_random_p = (byteLength) =>
  u8_randomFill_p(
    new Uint8Array(byteLength));

function as_u8_buffer(u8) {
  if (Uint8Array === u8.constructor) {
    return u8}
  if (u8.readInt8 || u8 instanceof ArrayBuffer) {
    return new Uint8Array(u8)}
  if (ArrayBuffer.isView(u8)) {
    return new Uint8Array(u8.buffer)}
  return Uint8Array.from(u8)}

function u8_concat(parts) {
  let i=0, len=0;
  for (const b of parts) {
    const byteLength = b.byteLength;
    if ('number' !== typeof byteLength) {
      throw new Error("Invalid part byteLength") }
    len += byteLength;}

  const u8 = new Uint8Array(len);
  for (const u8_part of parts) {
    u8.set(u8_part, i);
    i += u8_part.byteLength;}
  return u8}

export { as_u8_buffer, base2_to_u8, hex_to_u8, u8_concat, u8_json_codec, u8_randomFill_p, u8_random_p, u8_to_base2, u8_to_base64url, u8_to_hex, u8_to_utf8, utf8_to_u8, utf8_to_u8_nfkc };
//# sourceMappingURL=index.mjs.map
